import { CalendarEvent } from "@/ts/stores/event";
import { parse, format } from "fecha";

//const dateFormat = "YYYY-MM-DD";
const dateFormat = "DD-MM-YYYY";

function dateString(eventOrDateString: CalendarEvent | string) {
    if (!eventOrDateString.hasOwnProperty("acf")) {
        return format(parse(eventOrDateString as string, dateFormat)!, "ddd DD.MM.YY");
    } else {
        const event = eventOrDateString;
        const dates = (event as CalendarEvent).acf.info.dates;

        if (dates && dates.length === 1) {
            return format(parse(dates[0].date, dateFormat)!, "ddd DD.MM.YY");
        }

        if (dates && dates.length > 1) {
            const dateStrings: Array<string> = [];
            dateStrings.push(format(parse(dates[0].date, dateFormat)!, "DD.MM"));
            dateStrings.push(format(parse(dates[dates.length - 1].date, dateFormat)!, "DD.MM"));
            return dateStrings.join(" // ");
        }

        return "Geen datum";
    }
}

function getLastDate(event: CalendarEvent) {
    return parse(event.acf.info.dates.reduce((a: { date: string; doors: string; start: string; end: string }, b: { date: string; doors: string; start: string; end: string }) => (parse(a.date, dateFormat)! > parse(b.date, dateFormat)! ? a : b)).date, dateFormat)!;
}

function isPastEvent(event: CalendarEvent) {
    const lastDate = getLastDate(event);

    var now = new Date();
    now.setHours(0, 0, 0, 0);

    return lastDate < now;
}

export { dateString, getLastDate, isPastEvent };
